// Bezahlen über Stripe (server billtoro/billing-routes.ts): Der Server legt die Sitzung an, der Browser geht auf die
// Seite von Stripe und kommt danach auf /rechnung/tarif zurück (?checkout=ok&session=… oder ?checkout=abbruch).
import { api, ApiError, errorText } from '../api';
import type { BezahlPlan, TarifIntervall } from './types';

// Fehler beim Buchen oder im Portal als ruhiger Satz (Stripe-Einzelheiten nie in der Oberfläche)
export function bezahlFehler(err: unknown): string {
  if (!(err instanceof ApiError)) return errorText(err);
  if (err.code === 'billing_aus') return 'Bezahlung folgt in Kürze. Die Tarife können Sie schon ansehen.';
  if (err.code === 'kein_kunde') return 'Sie haben noch keinen Tarif gebucht. Wählen Sie unten einen Tarif.';
  if (err.code === 'stripe_fehler' || err.status === 502) return 'Stripe ist gerade nicht erreichbar. Bitte versuchen Sie es später noch einmal.';
  if (err.status === 429) return 'Das waren gerade viele Versuche. Bitte warten Sie einen Moment und versuchen Sie es dann noch einmal.';
  // preise_abweichend und alles andere: der Text vom Server
  return errorText(err);
}

// Tarif buchen. Hat die Firma schon ein bezahltes Abo (409 tarif_portal), geht der Wechsel über das Kundenportal.
export async function zurKasse(firmId: string, plan: BezahlPlan, intervall: TarifIntervall): Promise<void> {
  try {
    const { url } = await api.post<{ url: string }>(`/api/billtoro/${firmId}/checkout`, { plan, intervall });
    window.location.assign(url);
  } catch (err) {
    if (err instanceof ApiError && err.code === 'tarif_portal') return zumPortal(firmId);
    throw err;
  }
}

// Kundenportal von Stripe: Zahlungsart, Rechnungen, Tarif wechseln oder kündigen
export async function zumPortal(firmId: string): Promise<void> {
  const { url } = await api.post<{ url: string }>(`/api/billtoro/${firmId}/portal`);
  window.location.assign(url);
}

// Ein bezahltes Abo läuft (Wechsel und Kündigung dann über das Portal)
export const hatAbo = (t: { plan: string; status: string }) =>
  t.plan !== 'kostenlos' && (t.status === 'aktiv' || t.status === 'ueberfaellig' || t.status === 'gekuendigt');
